/** Quick Access targets — `page` matches DashBoard `activePage` / `?page=` query keys. */

export const QUICK_ACTIONS = [
  { id: 'proposal', label: 'Create Proposal', icon: 'filePlus', page: 'proposals' },
  { id: 'contract', label: 'Add Contract', icon: 'fileText', page: 'Contract', action: 'add' },
  { id: 'resource', label: 'Add Resource Update', icon: 'package', page: 'inventory-update', action: 'add' },
  { id: 'service', label: 'Add Service', icon: 'sparkles', page: 'services', action: 'add' },
  { id: 'customer', label: 'Add Customer', icon: 'userPlus', page: 'customer' },
  { id: 'report', label: 'Generate Report', icon: 'barChart', page: 'finance', tab: 'project-finance' },
];

export function buildAdminPageSearch(page, extra = {}) {
  const params = new URLSearchParams();
  if (page && page !== 'dashboard') {
    params.set('page', page);
  }
  Object.entries(extra).forEach(([key, value]) => {
    if (value != null && value !== '') params.set(key, String(value));
  });
  const qs = params.toString();
  return qs ? `?${qs}` : '';
}

export function patchAdminSearch(search, patch = {}, remove = []) {
  const raw = String(search || '').replace(/^\?/, '');
  const params = new URLSearchParams(raw);
  Object.entries(patch).forEach(([key, value]) => {
    if (value == null || value === '') params.delete(key);
    else params.set(key, String(value));
  });
  remove.forEach((key) => params.delete(key));
  const qs = params.toString();
  return qs ? `?${qs}` : '';
}
